export default __webpack_public_path__ + "static/media/4th-watermelon.bba7882e.png";